/** Validate the whole value: stripping letters turns browser SIP IDs into fake numbers. */
export function callNumber(value: unknown): string | null {
  if (typeof value !== 'string' || !/^\+?[\d\s().-]+$/.test(value.trim())) return null;
  const number = value.trim().replace(/[\s().-]/g, '');
  return /^\+?\d{3,15}$/.test(number) || /^00\d{3,15}$/.test(number) ? number : null;
}

interface CallerIdentity {
  user?: string;
  displayName?: string;
  assertedIdentity?: string;
  remotePartyId?: string;
  privacy?: string;
}
function addressNumber(value?: string): string | null {
  // Only the URI user part, never digits found in a display name, host or UUID.
  return callNumber(value?.match(/(?:^|<)\s*(?:sips?|tel):([^@;>\s]+)/i)?.[1]);
}

export function incomingCallNumber(identity: CallerIdentity): string | null {
  if ([identity.user, identity.displayName].some((value) => /^(anonymous|restricted|private|unavailable)$/i.test(value ?? '')) ||
      /(?:^|[;,\s])(?:id|user|header)(?:$|[;,\s])/i.test(identity.privacy ?? '') ||
      /;\s*privacy\s*=\s*(?:full|uri)/i.test(identity.remotePartyId ?? '')) return null;
  const userNumber = callNumber(identity.user);
  const displayNumber = callNumber(identity.displayName);
  const remotePartyNumber = /;\s*party\s*=\s*called/i.test(identity.remotePartyId ?? '')
    ? null : addressNumber(identity.remotePartyId);
  return addressNumber(identity.assertedIdentity) ?? remotePartyNumber ??
    (userNumber && userNumber.replace(/\D/g, '').length >= 7 ? userNumber : null) ??
    (displayNumber && displayNumber.replace(/\D/g, '').length >= 7 ? displayNumber : null) ?? userNumber;
}
